import { FieldArray, type FormikProps } from "formik";
import React, { type FC } from "react";
import { type SessionsView } from "../../../../types/state";
import { ValidatedForm } from "../../../../../../../components/forms";
import { RecurringSessionFormBuilder } from "./RecurringSessionFormBuilder/RecurringSessionFormBuilder";

interface RecurringSessionFormPropsOwn {
  isLoading?: boolean;
  onBlur: (propertyName: string) => void;
  disabled?: boolean;
  save: () => void;
}

export type RecurringSessionFormProps = RecurringSessionFormPropsOwn & {
  formik: FormikProps<SessionsView>;
};

export const RecurringSessionForm: FC<RecurringSessionFormProps> = (props: RecurringSessionFormProps) => {
  const { formik } = props;
  const renderFields = (): React.ReactNode => {
    const { onBlur, disabled, save } = props;
    return (
      <FieldArray
        name="sessions"
        render={(arrayHelpers) => (
          <RecurringSessionFormBuilder
            onChanged={save}
            sessions={formik.values.sessions}
            disabled={disabled}
            onBlur={onBlur}
            validatedFieldProps={formik}
            arrayHelpers={arrayHelpers}
          />
        )}
      />
    );
  };
  const { isLoading } = props;
  return (
    <ValidatedForm
      dirty={formik.dirty}
      isLoading={isLoading}
      formWidthComputer={16}
      withoutFormik
      disablePreventTransitionPrompt
    >
      {renderFields}
    </ValidatedForm>
  );
};

export default RecurringSessionForm;
